import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

import { mode } from 'template/material-theme'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    // ----------------------------------------------
    // Card

    cardGrid: {
      marginTop: theme.spacing(2),
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gap: theme.spacing(4),
    },

    cardColumn: {
      gridColumn: 'span 12',
      [theme.breakpoints.up('sm')]: { gridColumn: 'span 6' },
      [theme.breakpoints.up('md')]: { gridColumn: 'span 4' },
    },

    href: {
      color: 'inherit',
      textDecoration: 'inherit',
    },
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',

      '&:hover': {
        transform: 'translate(0, 0) scale(1.02)',
        transition: 'all .2s ease-in-out',
        boxShadow: `0 1px 6px ${theme.palette.primary.main}`,
      },
    },
    cardMedia: {
      aspectRatio: '16/9',
      boxSizing: 'border-box',
      backgroundSize: 'contain',
      backgroundClip: 'content-box',
      backgroundOrigin: 'content-box',
      backgroundRepeat: 'no-repeat',
      padding: '1.7rem',
      backgroundPosition: 'center',
      filter: mode === 'dark' ? 'invert(100%)' : undefined,
    },
    
    // ----------------------------------------------

  })
)

export default useStyles
